import ServiceAPI from './ServiceAPI.js'

export default class UsuarioServiceAPI extends ServiceAPI {
  async logarUsuario(login, senha) {
    return await this.http().post(
      'https://boleto.kskconsorcio.com.br:8184/login',
      {
        email: login,
        password: senha,
      },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
  }

  async uploadArquivoBoleto(formData) {
    return await this.http().post(
      'https://boleto.kskconsorcio.com.br:8184/api/boleto/upload-siens',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    )
  }

  async uploadArquivoUsuario(formData) {
    return await this.http().post(
      `https://boleto.kskconsorcio.com.br:8184/api/usuario/upload`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    )
  }

  async getUsuarios() {
    return await this.http().get(
      `https://boleto.kskconsorcio.com.br:8184/api/usuario`
    )
  }

  async getUsuariosPendentes() {
    return await this.http().get(
      `https://boleto.kskconsorcio.com.br:8184/api/usuario/pendentes`
    )
  }

  async getRemessaBoleto() {
    return await this.http().get(
      `https://boleto.kskconsorcio.com.br:8184/api/boleto/remessa`
    )
  }

  async reenviarBoleto(idBoleto) {
    return await this.http().get(
      `https://boleto.kskconsorcio.com.br:8184/api/boleto/reenviar-boleto?id=${idBoleto}`
    )
  }

  async updateUser(user) {
    return await this.http().put(
      `https://boleto.kskconsorcio.com.br:8184/api/usuario`,
      user
    )
  }

  async updateUserPendentes(user) {
    return await this.http().put(
      `https://boleto.kskconsorcio.com.br:8184/api/usuario`,
      user
    )
  }

  async downloadPdf(id) {
    await this.http()
      .post(
        `https://boleto.kskconsorcio.com.br:8184/api/boleto/download?id=${id}`,
        null,
        {
          responseType: 'blob',
        }
      )
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'boleto.pdf')
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
      .catch((error) => {
        console.error('Error downloading PDF:', error)
      })
  }

  async getUltimasRemessas() {
    return await this.http().get(
      `https://boleto.kskconsorcio.com.br:8184/api/boleto/remessa`
    )
  }

  async getRemessasFiltros(filtro) {
    return await this.http().post(
      `https://boleto.kskconsorcio.com.br:8184/api/boleto/filtro`,
      filtro
    )
  }

  async getLogsSistema() {
    return await this.http().get(
      `https://boleto.kskconsorcio.com.br:8184/api/log-envio`
    )
  }

  async reenviarRemessaBoleto(data) {
    return await this.http().post(
      `https://boleto.kskconsorcio.com.br:8184/api/boleto/reenviar-boleto-all`,
      data
    )
  }
}
